import { Link } from "react-router-dom";
import firebase from "firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";

const Chat = (props) => {
  const { dp, name, phone, lastText } = props.chat;
  return (
    <div className="chat flex-start">
      <img className="img" src={dp} />

      <div className="info flex-col-left-center">
        <Link to="/Chatroom" style={{ color: "black", textDecoration: "none" }}>
          <span
            className="chat-name"
            onClick={() => {
              localStorage.setItem("person-phone", phone);
            }}
          >
            {name}
          </span>
        </Link>
        <span className="last-text">{lastText}</span>
      </div>
    </div>
  );
};

const Chatpage = () => {
  const sender = parseInt(localStorage.getItem("user-phone", 10));
  const recepient = parseInt(localStorage.getItem("person-phone", 10));
  const firestore = firebase.firestore();
  const chatsRef = firestore
    .collection(`users/${sender}/chats`)
    .orderBy("createdAt", "desc");
  const [chats] = useCollectionData(chatsRef, { idField: "id" });

  return (
    <div className="chatpage">
      <header className="flex-start">
        <h2>amChat</h2>
      </header>

      <section className="flex-col-start">
        {chats &&
          chats.map((a) => {
            return <Chat key={Math.random} chat={a} />;
          })}
      </section>
    </div>
  );
};

export default Chatpage;
